import {ReactNode} from "react";

interface MobileOverlayActionSheetActionProps {
    children: ReactNode,
    className?: string,
}

function MobileOverlayActionSheetAction({children, className = ""}: MobileOverlayActionSheetActionProps) {
    return (
        <div className={`action-sheet__action ${className}`}>
            {children}
        </div>
    )
}

export default MobileOverlayActionSheetAction